import { Link } from "react-router-dom";

export interface FooterProps {
  company: string;
  address: string;
  rep: string;
  email: string;
}

export function Footer({ company }: FooterProps) {
  return (
    <footer className="page footer">
      <div className="footer-grid">
        <div>
          <p style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: "21px", letterSpacing: "-0.028em" }}>
            MathsHub
          </p>
          <p className="footer-note" style={{ marginTop: "var(--s-3)" }}>
            Maths homework, explained for busy parents. Find the sticking point, understand the next step and put useful practice within reach.
          </p>
        </div>
        <nav className="footer-links" aria-label="Footer">
          <Link to="/how-it-works">How it works</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/privacy">Privacy notice</Link>
          <Link to="/sources">Sources &amp; licences</Link>
          <Link to="/signin">Sign in</Link>
        </nav>
        <div>
          <p className="footer-note">
            {company}. Contact and company details are in our <Link to="/privacy">privacy notice</Link>.
          </p>
        </div>
      </div>
    </footer>
  );
}
